(function () {
  const STORAGE_KEY = 'midnight_kettle_wishlist';

  function getWishlist() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  }

  function setWishlist(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles } }));
  }

  function toggleWishlist(handle) {
    const handles = getWishlist();
    const idx = handles.indexOf(handle);
    if (idx > -1) {
      handles.splice(idx, 1);
    } else {
      handles.push(handle);
    }
    setWishlist(handles);
    return idx === -1;
  }

  function updateHeartButtons() {
    const handles = getWishlist();
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      const handle = btn.getAttribute('data-product-handle');
      if (handles.indexOf(handle) > -1) {
        btn.classList.add('is-wishlisted');
        btn.querySelector('.icon-heart').setAttribute('fill', '#eb85b5');
      } else {
        btn.classList.remove('is-wishlisted');
        btn.querySelector('.icon-heart').removeAttribute('fill');
      }
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    toggleWishlist(handle);
    updateHeartButtons();
  });

  document.addEventListener('DOMContentLoaded', updateHeartButtons);
})();
